import { Link } from 'react-router'
import { useAuth } from '@/auth/AuthProvider'
import { ImpersonationBanner } from '@/auth/ImpersonationBanner'
import { useDoc } from '@/data/hooks'
import { useClient } from '@/data/client'
import { Eyebrow } from '@/ui'

function Row({ id }: { id: string }) {
  const { data } = useClient(id)
  return (
    <li>
      <Link to={`/c/${id}`} className="flex items-center justify-between border-b border-gray-200 py-4 hover:text-ink">
        <span className="text-h5 font-body">{data?.name ?? id}</span>
        <span className="text-eyebrow uppercase tracking-eyebrow text-dim">Open →</span>
      </Link>
    </li>
  )
}

export function ClientPicker() {
  const { user } = useAuth()
  const { data } = useDoc<{ clientIds?: string[] }>(user ? `users/${user.uid}` : null)
  return (
    <>
      <ImpersonationBanner />
      <main id="main" className="mx-auto grid w-full max-w-form gap-8 px-6 py-16">
        <div className="grid gap-2">
          <Eyebrow tone="muted">Your portals</Eyebrow>
          <h1 className="text-h2">Which one today?</h1>
        </div>
        <ul>{(data?.clientIds ?? []).map((id) => <Row key={id} id={id} />)}</ul>
      </main>
    </>
  )
}
